import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import RentalHistory from '../../components/RentalHistory';
import { useAuth } from '../../contexts/AuthContext';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`history-tabpanel-${index}`}
      aria-labelledby={`history-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const HistoryTab: React.FC = () => {
  const { user } = useAuth();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  if (!user) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="body1">
          Veuillez vous connecter pour accéder à l'historique.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="historique des locations"
          sx={{
            '& .MuiTab-root': {
              color: '#C9B6AB',
              '&.Mui-selected': {
                color: '#C9B6AB',
                fontWeight: 'bold'
              }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#C9B6AB'
            }
          }}
        >
          <Tab label="Robes que j'ai louées" />
          <Tab label="Mes robes louées" />
        </Tabs>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <RentalHistory 
          userId={user.uid} 
          userType="renter" 
          title="Historique des robes que j'ai louées"
        />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <RentalHistory 
          userId={user.uid} 
          userType="owner" 
          title="Historique de mes robes louées"
        />
      </TabPanel>
    </Box>
  );
};

export default HistoryTab;
